import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	noSummary: {
		id: 'issue-create.common.no-summary',
		defaultMessage: '(No summary)',
		description:
			'Title to be displayed for the issue create modal in the mini and minimized state when there the summary field is empty',
	},
	noSummaryWithIssueType: {
		id: 'issue-create.common.no-summary-with-issue-type',
		defaultMessage: `{issueType, select,
            Task {New task}
            Subtask {New subtask}
            Story {New story}
            Bug {New bug}
            Epic {New epic}
            Idea {New idea}
            Request {New request}
            other {{issueType}}
        }`,
		description:
			'Title to be displayed for the issue create modal in the mini and minimized state when there the summary field is empty',
	},
	resizeSpotlightMessage: {
		id: 'issue-create.common.resize-spotlight-message',
		defaultMessage: 'Resize or minimize your issue to pause editing and navigate around Jira.',
		description:
			'Spotlight message to be displayed on the top right corner of the GIC modal view to explain how to use different modal sizes',
	},
	resizeSpotlightMessageIssuetermrefresh: {
		id: 'issue-create.common.resize-spotlight-message-issuetermrefresh',
		defaultMessage: 'Resize or minimize your issue to pause editing and navigate around Jira.',
		description:
			'Spotlight message to be displayed on the top right corner of the GIC modal view to explain how to use different modal sizes',
	},
	miniModalSpotlightMessage: {
		id: 'issue-create.common.mini-modal-spotlight-message',
		defaultMessage:
			'Create work in context and navigate your project without losing progress using the new create experience.{br}Expand to see the full view, or minimize to revisit it later. ',
		description:
			'Spotlight message to be displayed on the left side of the GIC modal view to explain the mini window',
	},
	miniModalSpotlightActionMessage: {
		id: 'issue-create.common.mini-modal-spotlight-action-message',
		defaultMessage: 'Got it',
		description: 'Spotlight action message to dismiss the spotlight',
	},
	miniModalSpotlightHeading: {
		id: 'issue-create.common.mini-modal-spotlight-heading',
		defaultMessage: 'Multitasking made easy',
		description: 'Spotlight heading',
	},
});
